import { Component, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
//import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// import { config } from '../config';
// import { environment } from '../../environments/environment';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {
  intimationList;
  intimationListData : [];
  error: string;
  loading: boolean;
  intimationNo: any;
  claimInfo: any;
  claimHistory:any;
  isHistory:boolean=false;
  mobileNumber: string;
  employeeName: string;
  policyNumber: string;
  claimant: string;
  relationWithEmployee: string;
  cardNumber: string;
  ailment: string;
  hospitalCity: string;
  hospitalName: string;
  estimatedAmount: string;
  admissionDate: string;
  dischargeDate: string;
  registeredDate: string;
  intimationNumber: string;
  status: string;
  claimStage: string;
  approvedAmount: string;
  claimNoByInsurer: string;
  checkStatusDetails: boolean = false;
  datecreate:string;
  selectedIntimation: string = "";
  private onDestroy$: Subject<void> = new Subject<void>();
  name: string;
  email: string;
  mobile: string;
  useId:any;
  // config: any = config;
  // environment: any = environment;
  // actionUrl: any;

  // @Output() intimationNo1 : any;

  constructor( private serviceURLService: serviceURLService,private router1: ActivatedRoute,public router: Router) {
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobileNumber');
    this.useId=localStorage.getItem('userID');
   }

  ngOnInit() {
    this.getIntimationNumberList();
    console.log(this.getIntimationNumberList());

  }


    //claim history status

  // getIntimationNumberList() {
  
  //   this.loading = true;
  //   this.mobileNumber = localStorage.getItem("mobileNumber");
  //   this.serviceURLService.getIntimationNumbersBy(this.mobileNumber).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
  //     this.loading = false;
  //     this.intimationListData = successData.data;
  //     this.intimationList = this.intimationListData.filter(function (intimationNo) {
  //       // console.log(this.intimationNo);
  //       return intimationNo != null;
  //     });
  //   }, errorData => {
  //     if (errorData.error.status === 403) {
  //       this.error = errorData.error.message;
  //     }
  //   });  
  // }

  getIntimationNumberList() {
  
    this.loading = true;
    this.mobileNumber = localStorage.getItem("mobileNumber");
    this.serviceURLService.getIntimationNumbersUsingNotify(this.mobileNumber).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.intimationListData = successData.response.pamResponse.data;
      this.intimationList = this.intimationListData.filter(function (intimationNo) {
        // console.log(this.intimationNo);
        return intimationNo != null;
      });
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });  
  }

  getClaimDetailByIntimationNo1() {
    this.saveClickEvent("Eclaim-Status");
    const intimationNo = this.selectedIntimation;
    const intimationNo1 = this.selectedIntimation;
    this.router.navigate(['/statusProgress',this.selectedIntimation]); // here "About" is path

  }

  saveClickEvent(clickOn) {
    var clickedData= {
     email: this.email,
     name: this.name,
     mobile: this.mobile,
     id:this.useId,
     type: clickOn
     }
   this.serviceURLService.saveClicked(clickedData).subscribe((successData: any) => {
     console.log("clicked data saved",clickOn);
   }, errorData => {
     console.log("clicked datanot saved",clickOn);
    
   })
 }


  getClaimDetailByIntimationNo() {
    const intimationNo = this.selectedIntimation;
    const intimationNo1 = this.selectedIntimation;
    if(intimationNo == "" || intimationNo == null) {
      this.error = "Claim Registration number is required.";
    } else {
    this.loading = true;
    this.checkStatusDetails = true;
    this.serviceURLService.getClaimInfoByIntimationNo(intimationNo).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.claimInfo = successData.response.pamResponse.data;
      for (var i = 0; i < this.claimInfo.length; i++) {
        this.employeeName = this.claimInfo[i].employeeName;
        this.policyNumber = this.claimInfo[i].policyNumber;
        this.claimant = this.claimInfo[i].claimant;
        this.relationWithEmployee = this.claimInfo[i].relationWithEmployee;
        this.cardNumber = this.claimInfo[i].cardNumber;
        this.ailment = this.claimInfo[i].ailment;
        this.hospitalCity = this.claimInfo[i].hospitalCity;
        this.hospitalName = this.claimInfo[i].hospitalName;
        this.estimatedAmount = this.claimInfo[i].estimatedAmount;
        this.admissionDate = this.claimInfo[i].admissionDate;
        this.dischargeDate = this.claimInfo[i].dischargeDate;
        this.registeredDate = this.claimInfo[i].dateCreated;
        this.intimationNumber = this.claimInfo[i].intimationNo;
        this.status = this.claimInfo[i].status;
        this.claimStage = this.claimInfo[i].claimStage ? this.claimInfo[i].claimStage : '-';
        this.approvedAmount = this.claimInfo[i].approvedAmount;
        if(this.approvedAmount == null) {
          this.approvedAmount = '-';
        }
        this.claimNoByInsurer = this.claimInfo[i].claimNoByInsurer;
        this.datecreate= this.registeredDate.split("T")[0];
      }

    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }
  }


  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }


  //claim history status

  // getClaimInfoByIntimation(){
  //   this.serviceURLService.getClaimHistoryByIntimation(this.intimationNumber).subscribe((success: any) => {
  //     this.claimHistory = success.data;
  //   }, errorData => {
  //     if (errorData.error.status === 403) {
  //       this.error = errorData.error.message;
  //     }
  //   });
  // }


}
